const apiUrl = process.env.REACT_APP_API_URL;
export const GetInteraccionsIdTasca = async (id_user : string, id_aula: string, id_tasca: string) => {
    try {
        const response = await fetch(`${apiUrl}:8061/usuaris/${id_user}/aula/${id_aula}/tasca/${id_tasca}/dubtes`);
        const jsonData = await response.json();
        return jsonData;
    } catch (error) {
        console.log('Error al obtener los datos:', error);
    }
};
